import firebase from "firebase";
import {
    ANNOUNCEMENTS_FIELD_CHANGED,
    DELETE_ANNOUNCEMENT,
    DELETE_ANNOUNCEMENT_FAILED,
    DELETE_ANNOUNCEMENT_SUCCESSFUL,
    FETCH_ANNOUNCEMENTS,
    FETCH_ANNOUNCEMENTS_FAILED,
    FETCH_ANNOUNCEMENTS_SUCCESSFUL,
    FETCH_MORE_ANNOUNCEMENTS,
    FETCH_MORE_ANNOUNCEMENTS_FAILED,
    FETCH_MORE_ANNOUNCEMENTS_SUCCESSFUL,
    FETCH_MORE_SCHEDULED_ANNOUNCEMENTS,
    FETCH_MORE_SCHEDULED_ANNOUNCEMENTS_FAILED,
    FETCH_MORE_SCHEDULED_ANNOUNCEMENTS_SUCCESSFUL,
    FETCH_SCHEDULED_ANNOUNCEMENTS,
    FETCH_SCHEDULED_ANNOUNCEMENTS_FAILED,
    FETCH_SCHEDULED_ANNOUNCEMENTS_SUCCESSFUL,
    HIDE_NEW_ANNOUNCEMENT_MODAL,
    PUSH_ANNOUNCEMENT, PUSH_SCHEDULED_ANNOUNCEMENT,
    SEND_ANNOUNCEMENT,
    SEND_ANNOUNCEMENT_FAILED,
    SEND_ANNOUNCEMENT_SUCCESSFUL,
    SHOW_NEW_ANNOUNCEMENT_MODAL,
} from "./Types";
import {message} from "antd";

//property declarations
const retrievedProject = localStorage.getItem('lalertInitializedProject');
let project = {};
if (retrievedProject) {
    project = JSON.parse(retrievedProject);
}


export const announcementsFieldChanged = ({ prop, value }) => {
    console.log({ prop, value });
    return {
        type: ANNOUNCEMENTS_FIELD_CHANGED,
        payload: { prop, value }
    }
};

//------------------------------------------------------ ALL ANNOUNCEMENTS -----------------------------------------------------------//

export const fetchAnnouncements = ({ startAt }) => {
    return(dispatch) => {
        dispatch({ type: FETCH_ANNOUNCEMENTS });
        firebase.firestore().collection("announcements")
            .orderBy("announcementDate", "desc").limit(startAt)
            .onSnapshot((snapshot) => {
                if (snapshot.size === 0) {
                    //there is no data
                    dispatch({ type: FETCH_ANNOUNCEMENTS_FAILED });
                } else {
                    let announcements = [];
                    snapshot.forEach(doc => {
                        const announcement = doc.data();
                        announcements.push(announcement);
                    });

                    dispatch({
                        type: FETCH_ANNOUNCEMENTS_SUCCESSFUL,
                        payload: { announcements, startAt }
                    });
                }
            }, function (e) {
                dispatch({ type: FETCH_ANNOUNCEMENTS_FAILED });
                console.log(e);
            })
    };
};

export const fetchMoreAnnouncements = ({ startAt }) => {

    return(dispatch) => {
        dispatch({ type: FETCH_MORE_ANNOUNCEMENTS });
        firebase.firestore().collection("announcements")
            .orderBy("announcementDate", "desc").limit(startAt)
            .get()
            .then((snapshot) => {
                if (snapshot.size === 0) {
                    //there is no data
                    dispatch({ type: FETCH_MORE_ANNOUNCEMENTS_FAILED });
                } else {
                    let announcements = [];
                    snapshot.forEach(doc => {
                        const announcement = doc.data();
                        announcements.push(announcement);
                    });

                    dispatch({
                        type: FETCH_MORE_ANNOUNCEMENTS_SUCCESSFUL,
                        payload: { announcements, startAt }
                    });
                }
            }).catch(e => {
            dispatch({ type: FETCH_MORE_ANNOUNCEMENTS_FAILED });
            console.log(e);
        })
    };
};

export const fetchScheduledAnnouncements = ({ startAt }) => {
    return(dispatch) => {
        dispatch({ type: FETCH_SCHEDULED_ANNOUNCEMENTS });
        firebase.firestore().collection("scheduledAnnouncements")
            .orderBy("announcementDate", "desc").limit(startAt)
            .onSnapshot((snapshot) => {
                if (snapshot.size === 0) {
                    //there is no data
                    dispatch({ type: FETCH_SCHEDULED_ANNOUNCEMENTS_FAILED });
                } else {
                    let announcements = [];
                    snapshot.forEach(doc => {
                        const announcement = doc.data();
                        announcements.push(announcement);
                    });

                    dispatch({
                        type: FETCH_SCHEDULED_ANNOUNCEMENTS_SUCCESSFUL,
                        payload: { announcements, startAt }
                    });
                }
            }, function (e) {
                dispatch({ type: FETCH_SCHEDULED_ANNOUNCEMENTS_FAILED });
                console.log(e);
            })
    };
};

export const fetchMoreScheduledAnnouncements = ({ startAt }) => {

    return(dispatch) => {
        dispatch({ type: FETCH_MORE_SCHEDULED_ANNOUNCEMENTS });
        firebase.firestore().collection("scheduledAnnouncements")
            .orderBy("announcementDate", "desc").limit(startAt)
            .get()
            .then((snapshot) => {
                if (snapshot.size === 0) {
                    //there is no data
                    dispatch({ type: FETCH_MORE_SCHEDULED_ANNOUNCEMENTS_FAILED });
                } else {
                    let announcements = [];
                    snapshot.forEach(doc => {
                        const announcement = doc.data();
                        announcements.push(announcement);
                    });

                    dispatch({
                        type: FETCH_MORE_SCHEDULED_ANNOUNCEMENTS_SUCCESSFUL,
                        payload: { announcements, startAt }
                    });
                }
            }).catch(e => {
            dispatch({ type: FETCH_MORE_SCHEDULED_ANNOUNCEMENTS_FAILED });
            console.log(e);
        })
    };
};

//------------------------------------------------------ SAVE ANNOUNCEMENTS -----------------------------------------------------------//

export const showNewAnnouncementModal = () => {
    return {
        type: SHOW_NEW_ANNOUNCEMENT_MODAL
    }
}

export const hideNewAnnouncementModal = () => {
    return {
        type: HIDE_NEW_ANNOUNCEMENT_MODAL
    }
}

export const sendAnnouncement = ({ announcementTitle, announcementDescription, isPDF, pdf, isScheduled, deadline, announcementDate, tags }) => {
    return(dispatch) => {
        dispatch({ type: SEND_ANNOUNCEMENT });

        const announcementID = Math.random().toString(36).substring(6).toUpperCase();

        if (isPDF) {
            //const fileName = pdf.name;

            const uploadTask = firebase.storage().ref(`announcementFiles/${announcementID}`)
                .put(pdf);

            uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
                function(snapshot) {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                        case firebase.storage.TaskState.PAUSED: // or 'paused'
                            console.log('Upload is paused');
                            break;
                        case firebase.storage.TaskState.RUNNING: // or 'running'
                            console.log('Upload is running');
                            break;
                        default:
                    }
                }, function(error) {

                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                        case 'storage/unauthorized':
                            // User doesn't have permission to access the object
                            break;

                        case 'storage/canceled':
                            // User canceled the upload
                            break;

                        case 'storage/unknown':
                            // Unknown error occurred, inspect error.serverResponse
                            break;
                        default:
                    }
                }, function() {
                    // Upload completed successfully, now we can get the download URL
                    uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                        console.log('File available at', downloadURL);

                        //check notification is scheduled
                        if (isScheduled) {
                            //check that announcement date is not empty
                            if (announcementDate) {
                                saveScheduledAnnouncement({ announcementID, deadline, announcementTitle, announcementDescription, announcementFile: downloadURL, announcementDate: announcementDate.toDate(), tags, dispatch })
                            } else {
                                message.warning('Kindly enter announcement date').then();
                                dispatch({ type: SEND_ANNOUNCEMENT_FAILED });
                            }
                        } else {
                            saveAnnouncementToDB({ announcementID, deadline, announcementTitle, announcementDescription, announcementFile: downloadURL, tags, dispatch });
                        }
                    });
                });
        } else {
            //check notification is scheduled
            if (isScheduled) {
                //check that announcement date is not empty
                if (announcementDate) {
                    saveScheduledAnnouncement({ announcementID, deadline, announcementTitle, announcementDescription, announcementFile: "", announcementDate: announcementDate.toDate(), tags, dispatch })
                } else {
                    message.warning('Kindly enter announcement date').then();
                    dispatch({ type: SEND_ANNOUNCEMENT_FAILED });
                }
            } else {
                saveAnnouncementToDB({ announcementID, deadline, announcementTitle, announcementDescription, announcementFile: "", tags, dispatch });
            }
        }
    };
}

function saveAnnouncementToDB({ announcementID, deadline, announcementTitle, announcementDescription, announcementFile, tags, dispatch }) {
    //post downloadURL and file name to an object in database
    const announcementDate = new Date();
    firebase.firestore().collection('announcements').doc(announcementID)
        .set({ announcementID, deadline, announcementTitle, announcementDescription, announcementFile, announcementDate, tags }, { merge: true })
        .then(() => {
            sendNotification({ dispatch, notificationTitle: announcementTitle, notificationMessage: announcementDescription });
        }).catch((error) => {
        console.log(error);
        dispatch({ type: SEND_ANNOUNCEMENT_FAILED });
    });
}

function saveScheduledAnnouncement({ announcementID, deadline, announcementTitle, announcementDescription, announcementFile, announcementDate, tags, dispatch }) {
    //post downloadURL and file name to an object in database
    firebase.firestore().collection('scheduledAnnouncements').doc(announcementID)
        .set({ announcementID, deadline, announcementTitle, announcementDescription, announcementFile, announcementDate, tags }, { merge: true })
        .then(() => {
            dispatch({ type: SEND_ANNOUNCEMENT_SUCCESSFUL });
        }).catch((error) => {
        console.log(error);
        dispatch({ type: SEND_ANNOUNCEMENT_FAILED });
    });
}

function sendNotification({ dispatch, notificationTitle, notificationMessage }) {
    //invoke custom database function
    const url = `${project.serverUrl}sendGeneralNotification`;
    fetch(url, {
        method: 'POST',
        body: JSON.stringify({ notificationTitle, notificationMessage }),
        mode: 'cors',
        headers: {'Content-Type': 'application/json'},
    }).then((response) => response.json())
        .then((response) => {
            console.log(response);
            dispatch({ type: SEND_ANNOUNCEMENT_SUCCESSFUL });
        }).catch((error) => {
        console.log("Here's your error deleting the user");
        console.log(error);
        dispatch({ type: SEND_ANNOUNCEMENT_FAILED });
    })
}

export const deleteAnnouncement = ({ announcement, path }) => {
    //post downloadURL and file name to an object in database
    return(dispatch) => {
        dispatch({ type: DELETE_ANNOUNCEMENT });
        let corePath = "announcements";
        if (path === "scheduled") {
            corePath = "scheduledAnnouncements";
        }

        firebase.firestore().collection(corePath).doc(announcement.announcementID)
            .delete()
            .then(() => {
                if (announcement.announcementFile) {
                    firebase.storage().ref(`announcementFiles/${announcement.announcementID}`)
                        .delete()
                        .then(() => {
                            dispatch({ type: DELETE_ANNOUNCEMENT_SUCCESSFUL });
                        })
                        .catch(e => {
                            console.log(e);
                            dispatch({ type: DELETE_ANNOUNCEMENT_FAILED });
                        })
                } else {
                    dispatch({ type: DELETE_ANNOUNCEMENT_SUCCESSFUL });
                }
            }).catch((error) => {
            console.log(error);
            dispatch({ type: DELETE_ANNOUNCEMENT_FAILED });
        });
    }
}

//-------------------------------------------------------

export const pushAnnouncement = (announcement) => {
    return {
        type: PUSH_ANNOUNCEMENT,
        payload: announcement
    }
}

export const pushScheduledAnnouncement = (announcement) => {
    return {
        type: PUSH_SCHEDULED_ANNOUNCEMENT,
        payload: announcement
    }
}